// src/components/Modals/SaveChangesModal.jsx
import React from 'react';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';

export default function SaveChangesModal({ onClose, onConfirm }) {
  return (
    <div className="modal-overlay">
      <div className="modal-window">
        {/* Кнопка закрытия */}
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Заголовок */}
        <h2 className="modal-title">Сохранить изменения?</h2>

        {/* Описание */}
        <div className="modal-form">
          <p className="modal-delete-text">
            Вы уверены, что хотите покинуть страницу?  
            Несохранённые данные будут потеряны.
          </p>
        </div>

        {/* Действия */}
        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Отмена
          </button>
          <button className="modal-button save" onClick={onConfirm}>
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
}
